import { BaseListModel } from "../base/base-list-model";
import { CountryModel } from "./country.model";

export const CountriesListModel = BaseListModel(CountryModel).named("Countries");
